import loadable from '@loadable/component';

export const OrgDashboardSelectOrgPageLoadable = loadable(
  () => import('./OrgDashboardSelectOrgPage.dynamic'),
);
